import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';

import ConnectedForm from './form';
import configureStore from './store/configure';

export default class DealForm extends React.Component {
  static propTypes = {
    allowStageChange: PropTypes.bool,
    allowTypeChange: PropTypes.bool,
    deal: PropTypes.object.isRequired,
    extraButton: PropTypes.node,
    features: PropTypes.object,
    fields: PropTypes.object,
    forUser: PropTypes.object,
    layout: PropTypes.string,
    options: PropTypes.object.isRequired,
    paths: PropTypes.object,
    stagesConfig: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDirtyChange: PropTypes.func,
    onSave: PropTypes.func.isRequired,
  }

  static defaultProps = {
    allowStageChange: true,
    allowTypeChange: true,
  };

  constructor(props) {
    super(props);

    const { extraButton, layout, onCancel, onDirtyChange, onSave, ...storeProps } = props;
    if (storeProps.deal.researchPropertyId) {
      storeProps.hidePropertySelector = true;
    }

    this.store = configureStore(storeProps);
  }

  render() {
    return (
      <Provider store={this.store}>
        <ConnectedForm
          extraButton={this.props.extraButton}
          layout={this.props.layout}
          onCancel={this.props.onCancel}
          onDirtyChange={this.props.onDirtyChange}
          onSave={this.props.onSave}
        />
      </Provider>
    );
  }
}
